import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Star, ShoppingBag } from "lucide-react";
import { api } from "@/lib/api";
import { ProductImage } from "@/components/ProductImage";

export default function Products() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data.filter((p) => p.active))).catch(() => {});
  }, []);

  return (
    <div className="animate-fade-in">
      <div className="px-5 pt-4 pb-3">
        <span className="text-[11px] font-semibold tracking-wider uppercase text-emerald-600 dark:text-emerald-400">Shop Wellness</span>
        <h1 className="text-2xl font-extrabold text-emerald-950 dark:text-emerald-50 font-head">Clinical Products</h1>
        <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">Dietitian-formulated supplements & superfoods</p>
      </div>

      <div className="px-4 grid grid-cols-2 gap-3 pb-4">
        {products.map((p) => (
          <div
            key={p.id}
            data-testid={`product-card-${p.id}`}
            className="bg-white dark:bg-emerald-900/60 rounded-2xl border border-slate-100 dark:border-emerald-800 overflow-hidden flex flex-col"
          >
            <div className="relative aspect-square bg-slate-100 dark:bg-emerald-800 overflow-hidden">
              <ProductImage product={p} />
              {p.tag && (
                <span className="absolute top-2 left-2 text-[10px] font-bold uppercase tracking-wide bg-emerald-700 text-white px-2 py-0.5 rounded-full">{p.tag}</span>
              )}
            </div>
            <div className="p-3 flex flex-col flex-1">
              <div className="flex items-center gap-1 text-[11px] text-amber-500 mb-1">
                <Star className="w-3 h-3 fill-amber-400 text-amber-400" />
                <span className="font-semibold">{p.rating}</span>
                <span className="text-slate-400">({p.reviews})</span>
              </div>
              <p className="text-sm font-semibold text-emerald-950 dark:text-emerald-50 leading-snug line-clamp-2">{p.name}</p>
              <p className="text-xs text-slate-400 mt-0.5">{p.weight}</p>
              <div className="mt-2 flex items-baseline gap-1.5">
                <span className="text-base font-bold text-emerald-700 dark:text-emerald-400">₹{p.price.toLocaleString("en-IN")}</span>
                <span className="text-xs text-slate-400 line-through">₹{p.original_price.toLocaleString("en-IN")}</span>
              </div>
              <button
                data-testid={`product-view-${p.id}`}
                onClick={() => navigate(`/products/${p.id}`)}
                className="mt-3 w-full flex items-center justify-center gap-1.5 bg-emerald-50 dark:bg-emerald-800 text-emerald-700 dark:text-emerald-300 text-xs font-bold py-2.5 rounded-xl hover:bg-emerald-100 dark:hover:bg-emerald-700 transition"
              >
                <ShoppingBag className="w-3.5 h-3.5" /> View Details
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
